import classNames from './styles.module.scss'


export default function BlockWrapper(props) {
  return (
    <div {...props} className={classNames.blockWrapper} data-testid="blockwrapper" />
  )
}
